import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { TechemTheme } from '@techem/techem-theme';
import phoneIcon from 'presentation/assets/icons/svg/phone.svg';
import Icon, { ICONSIZE } from 'presentation/components/Icon';
import { TrackerUtil } from 'tracking/TrackerUtil';

function Component({ t, i18n }: any) {
  var telHref = 'tel:' + t('headerPhoneSupportViewNumberToCall');
  return (
    <div className="d-flex flex-row mx-0 my-auto">
      <div className="mx-0 my-auto" style={{ width: '42px', height: '24px' }}>
        <Icon
          handleClick={() => {
            TrackerUtil.trackBtnClick('header_link_phone-support', 'link_phone-support');
            window.location.href = telHref;
          }}
          size={ICONSIZE.small}
          iconSrc={phoneIcon}
          alt="phone support icon"
        />
      </div>
      <Col className="d-none d-md-flex flex-column mx-0 my-auto px-3">
        <Row>
          <Col xs="auto" style={{ flex: 'inherit !important' }}>
            <span className="copy-s">{t('headerPhoneSupportViewTitle')}</span>
          </Col>
        </Row>
        <Row>
          <Col xs="auto" style={{ flex: 'inherit !important' }}>
            <a
              href={telHref}
              onClick={() => {
                TrackerUtil.trackBtnClick('header_link_phone-support', 'link_phone-support');
              }}
              className="fw-bold fs-4"
              style={{
                lineHeight: '1.5rem',
                textDecoration: 'inherit',
                color: TechemTheme.colors.primaryA
              }}
            >
              {t('headerPhoneSupportViewNumberToDisplay')}
            </a>
          </Col>
        </Row>
        <Row>
          <Col xs="auto" style={{ flex: 'inherit !important' }}>
            <span className="copy-s" style={{ whiteSpace: 'nowrap' }}>
              {t('headerPhoneSupportViewOperatingHoursNotice')}
            </span>
          </Col>
        </Row>
      </Col>
    </div>
  );
}

export default withTranslation()(Component);
